import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiWidgetTitle from 'components/MuiExtras/MuiWidgetTitle';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { UserStatisticsDto } from 'models/ApiModels';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    statistics: UserStatisticsDto;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const WidgetStatistics: React.FC<IProps> = ({ statistics }) => {
    const { t } = useTranslation();
    return (
        <MuiContainer margin="normal">
            <MuiWidgetTitle title={t("Views.User.Widgets.Statistics.BoxTitle")} />

            <MuiContainer margin="dense">
                <MuiColor variant="muted">
                    <table>
                        <thead>
                            <tr>
                                <td colSpan={2}>
                                    <b><Typography variant="button">{t("Views.User.Widgets.Statistics.Pub")}</Typography></b>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td align="right"><span>{statistics.questions}</span></td>
                                <td><span>{t("Views.User.Widgets.Statistics.Questions", { count: statistics.questions })}</span></td>
                            </tr>
                            <tr>
                                <td align="right"><span>{statistics.answers}</span></td>
                                <td><span>{t("Views.User.Widgets.Statistics.Answers", { count: statistics.answers })}</span></td>
                            </tr>
                            <tr>
                                <td align="right"><span>{statistics.posts}</span></td>
                                <td><span>{t("Views.User.Widgets.Statistics.Posts", { count: statistics.posts })}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </MuiColor>
            </MuiContainer>

            <MuiContainer margin="dense">
                <MuiColor variant="muted">
                    <table>
                        <thead>
                            <tr>
                                <td colSpan={2}>
                                    <b><Typography variant="button">{t("Views.User.Widgets.Statistics.ReputationTitle")}</Typography></b>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td align="right"><span>{statistics.publicationsViewed}</span></td>
                                <td><span>{t("Views.User.Widgets.Statistics.PublicationsViewed", { count: statistics.publicationsViewed })}</span></td>
                            </tr>
                            <tr>
                                <td align="right"><span>{statistics.likesReceivedBalance}</span></td>
                                <td><span>{t("Views.User.Widgets.Statistics.LikesReceived", { count: statistics.likesReceivedBalance })}</span></td>
                            </tr>
                            <tr>
                                <td align="right"><span>{statistics.thanksReceived}</span></td>
                                <td><span>{t("Views.User.Widgets.Statistics.ThanksReceived", { count: statistics.thanksReceived })}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </MuiColor>
            </MuiContainer>

            <MuiContainer margin="dense">
                <MuiColor variant="muted">
                    <table>
                        <thead>
                            <tr>
                                <td colSpan={2}>
                                    <b><Typography variant="button">{t("Views.User.Widgets.Statistics.ConectionsTitle")}</Typography></b>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td align="right"><span>{statistics.followers}</span></td>
                                <td><span>{t("Views.User.Widgets.Statistics.Followers", { count: statistics.followers })}</span></td>
                            </tr>
                            <tr>
                                <td align="right"><span>{statistics.following}</span></td>
                                <td><span>{t("Views.User.Widgets.Statistics.Folowing")}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </MuiColor>
            </MuiContainer>

        </MuiContainer>
    );
};

export default WidgetStatistics;